import { Box, styled } from '@mui/material';
import { HEADER, NAVBAR } from 'config';
import useCollapseDrawer from 'hooks/useCollapseDrawer';
import useResponsive from 'hooks/useResponsive';
import useSettings from 'hooks/useSettings';
import NavbarVertical from 'navbar/NavbarVertical';
import CustomerHeader from 'pages/customer_page/header/CustomerHeader';
import { useState } from 'react';
import { Outlet } from 'react-router-dom';

type MainStyleProps = {
  collapseClick: boolean;
};

const MainStyle = styled('main', {
  shouldForwardProp: (prop) => prop !== 'collapseClick',
})<MainStyleProps>(({ collapseClick, theme }) => ({
  flexGrow: 1,
  paddingTop: HEADER.MOBILE_HEIGHT,
  paddingBottom: HEADER.MOBILE_HEIGHT,
  [theme.breakpoints.up('lg')]: {
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: HEADER.DASHBOARD_DESKTOP_HEIGHT + 10,
    paddingBottom: HEADER.DASHBOARD_DESKTOP_HEIGHT - 30,
    width: `calc(100% - ${NAVBAR.DASHBOARD_WIDTH}px)`,
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    transition: theme.transitions.create('margin-left', {
      duration: theme.transitions.duration.shorter,
    }),
    ...(collapseClick && {
      marginLeft: NAVBAR.DASHBOARD_COLLAPSE_WIDTH,
    }),
  },
}));

const DashboardLayout = () => {
  const { collapseClick, isCollapse } = useCollapseDrawer();
  const { themeLayout } = useSettings();
  const isDesktop = useResponsive('up', 'lg');
  const [open, setOpen] = useState(false);
  const verticalLayout = themeLayout === 'vertical';

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <CustomerHeader isCollapse={isCollapse} onOpenSidebar={() => setOpen(true)} />
      <NavbarVertical isOpenSidebar={open} onCloseSidebar={() => setOpen(false)} />
      <MainStyle collapseClick={collapseClick}>
        <Box sx={{ pb: 5 }}>
          <Outlet />
        </Box>
      </MainStyle>
    </Box>
  );
};

export default DashboardLayout;
